export default __webpack_public_path__ + "static/media/icono-prod-equipo-camion.9175783d.png";